module.exports = __webpack_public_path__ + "img/webinar.7cf8de73.svg";